import CrudCustom from '../../../libs/custom/CrudCustom';

let SektorService = new CrudCustom('/pemegang-sahams');
export default SektorService;
